export default __webpack_public_path__ + "static/media/user-clock-solid.884d62b5.svg";